export const getComponentDataProps = ({ nodeID, nodeName, renderPathData, }) => ({
    'data-test': `preview.node.${nodeName}`,
    'data-node-id': nodeID,
    'data-node-render-path': (renderPathData === null || renderPathData === void 0 ? void 0 : renderPathData.renderID) || undefined,
});
